import { atom, useAtom } from 'jotai/index';

const isReadOnlyAtom = atom<boolean>(false);
const isDeactivatedSafeAtom = atom<boolean>(false);

export const useViewMode = () => {
  const [isReadOnly, setIsReadOnly] = useAtom(isReadOnlyAtom);
  const [isDeactivatedSafe, setIsDeactivatedSafe] = useAtom(isDeactivatedSafeAtom);

  return { isReadOnly, setIsReadOnly, isDeactivatedSafe, setIsDeactivatedSafe };
};
